import React, { useState } from "react";

import { Segmented } from "antd";
import ProfileMain from "../components/settings/ProfileMain";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import CandidateDetails from "../components/settings/CandidateDetails";
import { ROLES } from "../constants/UserRoles";

function Settings({ userRole }) {
  const [tab, setTab] = useState("Profile");
  const [userDataChanged, setuserDataChanged] = useState(1);
  console.log(userRole);

  return (
    <div className="hirePlusPlusPageContent">
      <Sidebar activePage="settings" userRole={userRole} />
      <div className="w-full hireplusplusRightContent">
        <Topbar
          userDataChanged={userDataChanged}
          activePage="settings"
          driverFlag="settings"
          userRole={userRole}
          noNavigate={true}
          newTitle="Account Settings"
        />
        <div className="px-7 py-5">
          {/* <p className="text-[#101828] font-semibold text-[1.8rem] mb-3">
            Account Settings
          </p> */}
          {userRole === ROLES.org_admin ||
          userRole === ROLES.b2b_candidate ? null : (
            <Segmented
              options={[
                {
                  label: "Profile",
                  value: "Profile",
                  className: "driver-profile",
                },
                {
                  label: "Candidate details",
                  value: "Candidate details",
                  className: "driver-candidate",
                },
              ]}
              onChange={(value) => {
                setTab(value);
              }}
              className="w-full sm:w-[70%] lg:w-[50%] xl:w-[36%]"
              block
              size="large"
            />
          )}
          <div>
            {tab === "Profile" && (
              <ProfileMain
                setuserDataChanged={setuserDataChanged}
                userDataChanged={userDataChanged}
              />
            )}
          </div>
          <div>{tab === "Candidate details" && <CandidateDetails />}</div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
